import { useQuery } from '@tanstack/react-query';
import { GlobalQueryKeys } from '@enums/react-query-keys';
import { WelcomeVoucher } from '@interfaces/models/welcomeVoucher';
import { TouchPoint } from '@interfaces/common/common';
import { AppCookies } from '@enums/cookies';
import Cookies from 'universal-cookie';
import { getWelcomeVoucher } from '@api/contents';

const useWelcomeVoucherQuery = ({
  touchPoint,
  productId,
  enabled = true,
}: {
  touchPoint: TouchPoint;
  productId?: string;
  enabled?: boolean;
}) => {
  const newCookieInstance = new Cookies();
  const clientAnonymousId = newCookieInstance.get<string>(AppCookies.ANONYMOUS_USER_ID_CSR);

  const query = useQuery<WelcomeVoucher>({
    queryKey: [GlobalQueryKeys.WELCOME_VOUCHER, touchPoint, productId],
    queryFn: () => getWelcomeVoucher(touchPoint, clientAnonymousId, null, productId),
    enabled,
    staleTime: Infinity,
    placeholderData: null,
    retry: false,
  });

  return {
    welcomeVoucher: query.data,
    refetch: query.refetch,
  };
};

export default useWelcomeVoucherQuery;
